// extracted by mini-css-extract-plugin
export default {"shareModalWrapper":"Editor_shareModalWrapper__V1I+h"};